/**
 *
 * This file provides environment-specific information to the front end.
 *
 * DO NOT USE FOR CREDENTIALS OR OTHER SECRETS.
 *
 * When adding a value, ensure that it is present in all three config
 * files: dev, staging, and prod.
 *
 * Do not edit index.ts. It will be overwritten.
 *
 * During development, npm start will copy the dev version to index.
 *
 * During deployment, the build settings at amplify.yaml will copy
 * staging and prod versions to index, as appropriate.
 *
 */

export const ENV = 'prod';
export const GA_ID = 'UA-221064469-1';
